import { Switch, Tooltip } from "antd";
import Title from "antd/es/typography/Title";
import { useAuth } from "../../contexts/auth";
import { InfoCircleOutlined } from "@ant-design/icons";
import { updateRenewAmount } from "../../services/account/api";
import { createNotification } from '../Notification';
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useCredits } from "../../library/hooks/useCredits";

export function Balance() {
  const { partner, RefreshUser } = useAuth();
  const [renewLoading, setRenewLoading] = useState(false);

  const {
    renewCreditSwitch,
    setRenewCreditSwitch,
    selectedAmount,
  } = useCredits();

  const intl = useIntl();
  let dollarFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  // useEffect(() => { RefreshUser(); }, [RefreshUser]);

  const handleCheck = (value) => {
    setRenewLoading(true);

    const renew_amount = value ? `${selectedAmount}00` : 0;

    updateRenewAmount({ renew_amount })
      .then(() => {
        setRenewCreditSwitch(!!renew_amount)
        RefreshUser();
      })
      .catch((err) => {
        createNotification(
          "error",
          intl.formatMessage({ id: "general_error" }),
          intl.formatMessage({ id: "general_error.description" })
        );
      })
      .finally(() => {
        setRenewLoading(false);
      })
  }

  return (
    <>
      <Title level={5} style={{ margin: 0 }}>
        <FormattedMessage id="page.myAccount.financial.actualBalance.title" />
      </Title>
      <Title level={2} className="!text-primary" style={{ margin: 0 }}>{dollarFormatter.format(partner.balance)}</Title>
      <div className="my-2 gap-x-2 flex text-center">
        <Switch checked={renewCreditSwitch} loading={renewLoading} onChange={handleCheck} className="bg-gray-200" />
        <Title level={5} style={{ margin: 0 }}>
          <FormattedMessage id="page.my_account.financial.renew_credits" />
        </Title>
        <div className="cursor-pointer flex items-center">
          <Tooltip placement="right" title={<FormattedMessage id="page.my_account.financial.renew_credits.info" />}>
            <InfoCircleOutlined
              className="text-lg"
            />
          </Tooltip>
        </div>
      </div>
    </>
  )
}
